import { render, staticRenderFns } from "./person_info_all.vue?vue&type=template&id=442a0c2e&scoped=true"
import script from "./person_info_all.vue?vue&type=script&lang=js"
export * from "./person_info_all.vue?vue&type=script&lang=js"
import style0 from "./person_info_all.vue?vue&type=style&index=0&id=442a0c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a0c2e",
  null
  
)

export default component.exports